.list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: var(--t-body);
  line-height: 1.5;
  color: var(--ink);
}

.item a {
  font-size: var(--t-dense);
}
